// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".card-profile[data-v-e80d5cba]{padding:var(--spacing-xs) var(--spacing-l) var(--spacing-s) var(--spacing-2xl)}ul[data-v-e80d5cba]{list-style:none;padding:0;margin:0}.menu-section[data-v-e80d5cba]{display:flex;flex-direction:column;gap:var(--spacing-xs);align-items:stretch;justify-content:start;margin:0 var(--composed-menu-profile-content-menu-sections-margin, var(--spacing-l))}hr[data-v-e80d5cba]{margin:var(--spacing-xs) 0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
